module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-92.99b09c56.svg";